import { render, staticRenderFns } from "./BAPlantsMap.vue?vue&type=template&id=92f20cd2&"
import script from "./BAPlantsMap.vue?vue&type=script&lang=js&"
export * from "./BAPlantsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports